import {Injectable} from "@angular/core";
import {ProductRemote} from "@app/core/product/domain/repositories/product.remote";
import {Observable} from "rxjs";
import {Product} from "@app/core/product/domain/dtos/product";

@Injectable({
    providedIn: 'root'
})
export class GetSimilarProductsUseCase {

    constructor(private productRemote:ProductRemote) {
    }

    execute(productCode: string, itemsPerPage: number, page: number): Observable<Product[]> {
        return this.productRemote.getSimilarProducts(productCode, itemsPerPage, page)
    }
}